<template>
  <div>
<!--    <el-row>-->
<!--      <el-col :span="24">-->
<!--        -->
<!--      </el-col>-->
<!--    </el-row>-->
    <el-row v-show="viewDisplay" style="display: flex;height: 67px;overflow: auto">
      <block-select :type="templateInfo!=undefined && templateInfo.type=='chart_wellGroup'?'wellgroup':chartType" ref="blkSel"></block-select>
      <div class="block">
        <!--          <el-card shadow="hover" :body-style="{padding:'5px'}" style="width: 315px">-->
        <span style="font-size: 14px;color: #606266;font-family: '方正大黑简体';font-weight: bold;">日期：</span>
        <div v-if="frameTimeType=='年月'" style="display: inline-block">
          <el-date-picker
              size="small"
              v-model="frameYear.startTime"
              type="month"
              value-format="YYYYMM"
              placeholder="开始"
              @change="selectYear($event,'start')"
              :disabled-date="disabledFrameMonStart"
              style="width: 140px"
          ></el-date-picker>
          ~
          <el-date-picker
              size="small"
              v-model="frameYear.endTime"
              type="month"
              value-format="YYYYMM"
              placeholder="结束"
              @change="selectYear($event,'end')"
              :disabled-date="disabledFrameMonEnd"
              style="width: 140px"
          ></el-date-picker>
        </div>
        <div v-else-if="frameTimeType=='年'" style="display: inline-block">
          <el-date-picker
              size="small"
              v-model="frameYear.startTime"
              type="year"
              value-format="YYYY"
              placeholder="开始"
              @change="selectYear($event,'start')"
              :disabled-date="disabledFrameYearStart"
              style="width: 140px"
          ></el-date-picker>
          ~
          <el-date-picker
              size="small"
              v-model="frameYear.endTime"
              type="year"
              value-format="YYYY"
              placeholder="结束"
              @change="selectYear($event,'end')"
              :disabled-date="disabledFrameYearEnd"
              style="width: 140px"
          ></el-date-picker>
        </div>
        <div v-else-if="frameTimeType=='年月日'" style="display: inline-block">
          <el-date-picker
              size="small"
              v-model="frameYear.startTime"
              type="date"
              value-format="YYYY-MM-DD"
              placeholder="开始"
              @change="selectYear($event,'start')"
              :disabled-date="disabledFrameDayStart"
              style="width: 140px"
          ></el-date-picker>
          ~
          <el-date-picker
              size="small"
              v-model="frameYear.endTime"
              type="date"
              value-format="YYYY-MM-DD"
              placeholder="结束"
              @change="selectYear($event,'end')"
              :disabled-date="disabledFrameDayEnd"
              style="width: 140px"
          ></el-date-picker>
        </div>
        <!--            <el-date-picker-->
        <!--                size="small"-->
        <!--                v-else-if="frameTimeType=='年月日'"-->
        <!--                v-model="frameTime"-->
        <!--                type="daterange"-->
        <!--                @change="selectTime"-->
        <!--                value-format="YYYY-MM-DD"-->
        <!--                range-separator="至"-->
        <!--                start-placeholder="开始"-->
        <!--                end-placeholder="结束"-->
        <!--            ></el-date-picker>-->
        <!--          </el-card>-->
      </div>
<!--      <el-col style="padding-top: 10px">-->

        <el-dropdown style="margin-left:10px;margin-top: 10px" class="newChartBtn" size="mini" split-button type="primary" @click="clickEditConfig">
          修改模板
          <template #dropdown>
            <el-dropdown-menu class="xxx">
              <el-dropdown-item @click="clickNewConfig" icon="el-icon-edit">新建模板</el-dropdown-item>
              <el-dropdown-item @click="clickSwitchConfig" icon="el-icon-sort">切换模板</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <el-dropdown style="margin-top: 10px" class="newChartBtn" size="mini" split-button type="primary" @click="clickSaveConfig">
          保存配置
          <template #dropdown>
            <el-dropdown-menu class="xxx">
              <el-dropdown-item @click="clickSaveAsConfig" icon="el-icon-copy-document">另存配置</el-dropdown-item>
              <el-dropdown-item @click="clickSaveSystemConfig" icon="el-icon-copy-document">存为系统配置</el-dropdown-item>
              <el-dropdown-item @click="clickSavepublicConfig" icon="el-icon-copy-document">存为公用配置</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <div style="margin-top: 10px" class="newChartBtn" v-if="templateInfo!=undefined && templateInfo.type=='chart_wellGroup'">
          <el-button size="mini" type="primary" @click="celectionWellGroup">选井</el-button>
        </div>
        <div style="margin-top: 10px" class="newChartBtn" v-if="chartType=='wellgroup'&&$refs.blkSel.blkTypeGroupId!='04'">
          <el-button size="mini" type="primary" @click="clickSelectionWell">选井</el-button>
        </div>
        <div style="margin-top: 10px" class="newChartBtn" v-if="forecastTableData.length!=0">
          <el-button size="mini" type="primary" @click="forecastOk">提交预测数据</el-button>
        </div>
        <el-dropdown style="margin-top: 10px" size="mini" split-button type="primary" @command="exportImage" @click="exportImage('svg')">
        <i class="el-icon-download" :font-size="20"></i>
        导出
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item icon="el-icon-picture" command="svg">SVG 图片</el-dropdown-item>
            <el-dropdown-item icon="el-icon-picture" command="png">PNG 图片</el-dropdown-item>
            <el-dropdown-item icon="el-icon-picture" command="jpeg">JPEG 图片</el-dropdown-item>
            <el-dropdown-item icon="el-icon-document" command="pdf">PDF 文档</el-dropdown-item>
            <el-dropdown-item icon="el-icon-document" command="excel">excel 文档</el-dropdown-item>

          </el-dropdown-menu>
        </template>
      </el-dropdown>
        <div style="margin-top: 10px" class="newChartBtn">
          <el-button size="mini" type="primary" @click.stop="wellsTimeConfig">刷新</el-button>
        </div>
<!--      </el-col>-->
<!--      <el-col :span="7">-->
<!--        -->
<!--      </el-col>-->
<!--      <div class="wellsName" v-if="chartType=='normal'">-->
<!--        <el-card :body-style="{padding:'9px'}">-->
<!--          对象：{{ wells[0] }}-->
<!--        </el-card>-->
<!--      </div>-->
    </el-row>
    <el-row v-if="viewDisplay && isFitting" style="margin-bottom: 50px;height: 250px">
      <fieldset>
        <legend>拟合设置</legend>
        <el-button size="small" @click="onFitting">拟合</el-button>
        <el-button size="small" @click="emptyFitting">清除</el-button>
        <el-button size="small" @click="forecastFitting">预测</el-button>
        <el-divider />
        <el-col span="6">
          <el-table :data="fittingDatas" height="150" stripe border fit highlight-current-row @current-change="forecastCurrentChange">
            <el-table-column label="" prop="name" width="110px"></el-table-column>
            <el-table-column label="开始时间" prop="start"></el-table-column>
            <el-table-column label="结束时间" prop="end"></el-table-column>
            <el-table-column label="递减类型" prop="" width="130px">
              <template #default="scope">
                <el-select v-model="fittingDatas[scope.$index].type"  placeholder="未选择">
                  <el-option
                      v-for="item in fittingtype"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="拟合公式" prop="formula" width="260px">
              <template #default="scope">
                <div style="text-align: center">{{fittingDatas[scope.$index].formular}}</div>
              </template>
            </el-table-column>
            <el-table-column label="相关系数" prop="r">
              <template #default="scope">
                <div style="text-align: center">{{fittingDatas[scope.$index].r}}</div>
              </template>
            </el-table-column>
            <el-table-column label="初始产量" prop="Q0" >
              <template #default="scope">
                <!--                <el-input v-model="fittingDatas[scope.$index].Q0" size="small" />-->
                <div style="text-align: center">{{fittingDatas[scope.$index].Q0}}</div>
              </template>
            </el-table-column>
            <!--            <el-table-column label="初始递减率" prop="ai" width="100px">-->
            <!--              <template #default="scope">-->
            <!--&lt;!&ndash;                <el-input v-model="fittingDatas[scope.$index].ai" size="small" />&ndash;&gt;-->
            <!--                <div style="text-align: center">{{fittingDatas[scope.$index].ai}}</div>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column label="递减指数" prop="n">-->
            <!--              <template #default="scope">-->
            <!--&lt;!&ndash;                <el-input v-model="fittingDatas[scope.$index].n" size="small" />&ndash;&gt;-->
            <!--                <div style="text-align: center">{{fittingDatas[scope.$index].n}}</div>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <el-table-column label="递减率" prop="a">
              <template #default="scope">
                <!--                <el-input v-model="fittingDatas[scope.$index].a" size="small" />-->
                <div style="text-align: center">{{fittingDatas[scope.$index].a}}</div>
              </template>
            </el-table-column>
            <el-table-column label="拟合数据" prop="">
              <template #default="scope">
                <el-button type="primary" size="small" @click="onFittingDataSee(scope.$index, scope.row)">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作" prop="">
              <template #default="scope">
                <el-button type="danger" size="small" @click="onFittingDataDelete(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </fieldset>

    </el-row>

    <!--        {{templateInfo}}-->
    <highchart v-loading="loading" v-show="viewDisplay" ref="highchart" :id="id" :option="option" :chart-type="chartType"/>

    <!--  预测报表  -->
    <div v-show="forecastTableData.length!=0" :style="'margin-top: 400px'">
      <el-divider content-position="center" style="font-size: 20px">预测产量报表</el-divider>
      <el-table :data="forecastTableData" @cell-dblclick="editData "  border stripe max-height="100%">
        <el-table-column
            v-for="item in forecastTableHeader"
            :prop="item.id"
            :label="item.name"
            :key="item.id">
          <template #default="scope">
            <el-input v-if="scope.row[scope.column.property + 'isShow']"
                      :ref="scope.column.property"
                      v-model="scope.row[scope.column.property]"
                      @blur="alterData(scope.row,scope.column)"></el-input>
            <span v-else>{{ scope.row[scope.column.property] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--      模板配置页面-->
    <div v-show="isShow" class="newChartBg"><!--新建图表的遮罩层-->
      <div  class="newChart">
        <div class="header">
          <span v-if="changeConfigNow == ''">统计图配置</span>
          <span v-else>{{changeConfigNow}}</span>
        </div>
        <!--<newTableTree ref="newTableTree" :changeName="newName" :massage="jsons" v-if="isShow" class="left" v-on="{clickTree:clickTree,removeTree:removeTree}"></newTableTree>-->
        <newChart v-loading="loadingChaet" class="table right" ref="newChart" v-on="{sub:sub,changeName:changeName}"
                  :jsons="jsons"  :massage="obj"  :wells="wells" :center_wells="center_wells" :relation_wells="relation_wells"
                  :frameTime="frameTime" :isFitting="isFitting" :form_options="formOptions" :data_UsrTree="dataUsrTree"
                  v-if="isShow" ></newChart>
        <div class="btn">
          <el-button @click="goBack">返回</el-button>
          <el-button @click="submit">提交</el-button>
        </div>
      </div>
    </div>
    <!--      保存配置页面-->
    <div v-dialogDrag>
      <el-dialog
          v-model="dialogVisible"
          title="配置"
          width="30%"
          v-show="viewDisplay"
      >
        <el-form>
          <el-form-item label="请输入配置名称">
            <el-input v-model="save_config_name"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="configNameOk">确认</el-button>
            </span>
        </template>
      </el-dialog>
    </div>
    <!--      切换配置页面 -->
    <div v-dialogDrag>
      <el-dialog v-model="changeDialogVisible"
                 title="切换配置"
                 width="30%"
                 v-show="viewDisplay"
      >
        <el-card>
          <el-form>
            <el-form-item>
              <el-radio-group @change="changeConfig" v-model="switch_config_name">
                <el-form-item v-for="(i,idx) in changeConfigList" :key="i">
                  <el-radio :label="i.config_name" @dblclick="dblclickConfigName(i)">
                    <el-input v-if="i.isShow"
                              :ref="i.config_name"
                              v-model="i.config_name"
                              @blur="updateConfigName(i,idx)" size="small"></el-input>
                    <span v-else>{{ i.config_name }}</span>
                  </el-radio>
                </el-form-item>
                <el-form-item>
                  <el-radio label="defaultTemplate">系统配置模板</el-radio>
                </el-form-item>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </el-card>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="changeDialogVisible = false">取消</el-button>
                <el-button type="danger" :disabled="ddisable" @click="changeConfigDel">删除</el-button>
                <el-button type="primary" @click="changeConfigOk">确认</el-button>
            </span>
        </template>
      </el-dialog>
    </div>
    <!--    选井页面（指标分析）-->
    <div v-dialogDrag>
      <el-dialog
          v-model="selectionWellGroup"
          title="选井"
          width="35%">
        <el-form :inline="true" label-width="90px">
          <el-row>
            <el-col :span="10">
              <el-form-item label="井组1">
                <el-select v-model="relation_grupone_name" @change="onRelationGroupOneChange" size="small">
                  <el-option
                      v-for="item in relation_grup_list"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" :offset="4">
              <el-form-item label="井组2">
                <el-select v-model="relation_gruptwo_name" @change="onRelationGroupTwoChange" size="small">
                  <el-option
                      v-for="item in relation_grup_list"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="井组名称：">
                <el-input size="small" v-model="relations.relation_grupone_name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" :offset="4">
              <el-form-item label="井组名称：">
                <el-input size="small" v-model="relations.relation_gruptwo_name"></el-input>
              </el-form-item>

            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="井组列表：">
                <el-input size="small" v-model="relation_grupone_filterText" placeholder="筛选井"></el-input>
              </el-form-item>
              <el-scrollbar height="260px">
                <el-tree
                    class="filter-tree"
                    :data="wellgroupOneData"
                    :props="defaultProps"
                    node-key="id"
                    show-checkbox
                    @check="handleWellCheckOne"
                    ref="relationsOneTree"
                    :filter-node-method="relationsFilterNode"
                    default-expand-all
                    :default-expanded-keys="relations.relations_grupone_checkedKeys"
                    :default-checked-keys="relations.relations_grupone_checkedKeys">
                </el-tree>
              </el-scrollbar>
            </el-col>
            <el-col :span="10" :offset="4">
              <el-form-item label="井组列表：">
                <el-input size="small" v-model="relation_gruptwo_filterText" placeholder="筛选井"></el-input>
              </el-form-item>
              <el-scrollbar height="260px">
                <el-tree
                    class="filter-tree"
                    :data="wellgroupTwoData"
                    :props="defaultProps"
                    node-key="id"
                    show-checkbox
                    @check="handleWellCheckTwo"
                    ref="relationsTwoTree"
                    default-expand-all
                    :filter-node-method="relationsFilterNode"
                    :default-expanded-keys="relations.relations_gruptwo_checkedKeys"
                    :default-checked-keys="relations.relations_gruptwo_checkedKeys">
                </el-tree>
              </el-scrollbar>
            </el-col>
          </el-row>
        </el-form>
        <template #footer>
                <span class="dialog-footer">
                    <el-button @click="selectionWellGroup = false">取消</el-button>
                    <el-button type="primary" @click="wellsTimeConfig()">确认</el-button>
                </span>
        </template>
      </el-dialog>
    </div>
    <!--    选井页面（井组曲线） -->
    <div v-dialogDrag>
      <el-dialog
          v-model="viewSelectionWell"
          title="选井"
          width="35%"
          v-show="viewDisplay">
        <el-form label-width="70px">
          <el-row>
            <el-col :span="10">
              <el-form-item label="中心井:">
                <el-input size="small" v-model="relation_grupone_filterText" placeholder="筛选"></el-input>
              </el-form-item>
              <el-scrollbar height="260px">
                <el-tree icon-class=""
                         class="filter-tree"
                         :data="wellgroupData"
                         :props="defaultProps"
                         node-key="label"
                         highlight-current
                         default-expand-all
                         :default-expanded-keys="defexpandBlk"
                         :filter-node-method="filterWellNode"
                         @node-click="handleWellCheckChange"
                         ref="centerWellTree">
                  <template #default="{ node }">
                    <div>
                      <el-image :src="getWellNodeIcon(data,node)" lazy
                                style="margin:0px 0px 0 0px; width:16px;height:16px"></el-image>
                      <span class="custom-tree-node">
                  <span>{{ node.label }}</span>
                </span>
                    </div>
                  </template>
                </el-tree>
              </el-scrollbar>
            </el-col>
            <el-col :span="10" :offset="4">
              <el-form-item label="关联井：">
                <el-input size="small" v-model="relation_gruptwo_filterText" placeholder="筛选"></el-input>
              </el-form-item>
              <el-scrollbar height="260px">
                <el-tree
                    class="filter-tree"
                    :data="wellgroupData"
                    :props="defaultProps"
                    node-key="id"
                    show-checkbox
                    @check="handleCheckChange"
                    :default-expanded-keys="defexpandBlk"
                    :default-checked-keys="defcheckedBlk"
                    :filter-node-method="filterWellNode"
                    ref="relationWellTree">
                  <template #default="{ node }">
                    <div>
                      <el-image :src="getWellNodeIcon(data,node)" lazy
                                style="margin:0px 0px 0 0px; width:16px;height:16px"></el-image>
                      <span class="custom-tree-node">
                  <span>{{ node.label }}</span>
                </span>
                    </div>
                  </template>
                </el-tree>
              </el-scrollbar>
            </el-col>
          </el-row>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="viewSelectionWell = false">取消</el-button>
                <el-button type="primary" @click="wellsTimeConfig()">确认</el-button>
            </span>
        </template>
      </el-dialog>
    </div>
    <!--     拟合选值页面-->
    <div v-dialogDrag>
      <el-dialog
          v-model="viewBoxSelection"
          title="拟合选值"
          width="25%"
          v-show="viewDisplay"
      >
        <el-table
            ref="multipleTableRef"
            :data="dataBoxSelection"
            @selection-change="dataBoxSelectionChange"
            stripe
            border
            height="300">
          <el-table-column type="selection" width="30"/>
          <el-table-column :label=option[selectedChartIndex].xAxis.a_type prop="name" width="180"></el-table-column>
          <el-table-column :label=option[selectedChartIndex].yAxis[0].title.text prop="y" width="180"></el-table-column>
        </el-table>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="viewBoxSelection = false">取消</el-button>
                <el-button type="primary" @click="dataBoxSelectionOk">确认</el-button>
            </span>
        </template>
      </el-dialog>
    </div>
    <!--     产量预测页面-->
    <div v-dialogDrag>
      <el-dialog
          v-model="viewBoxForecast"
          title="产量预测"
          width="400px"
          v-show="viewDisplay"
      >
        <div>
          <el-row class="forecastRow">
            <el-col :span="6">初始产量</el-col>
            <el-col :span="7">
              <el-input v-model="forecastData.initialProduction"></el-input>
            </el-col>
          </el-row>
          <el-row class="forecastRow">
            <el-col :span="6">预测起始时间</el-col>
            <el-col :span="10">
              <el-date-picker
                  style="width: 100%"
                  :disabled-date="disabledDateStart"
                  v-model="forecastData.startTime"
                  type="month"
                  placeholder="请选择时间"
              />
            </el-col>
          </el-row>
          <el-row class="forecastRow">
            <el-col :span="6">预测结束时间</el-col>
            <el-col :span="10">
              <el-date-picker
                  style="width: 100%"
                  v-model="forecastData.endTime"
                  type="month"
                  placeholder="请选择时间"
                  :disabled-date="disabledDateEnd"
                  :default-value="forecastData.startTime"
              />
            </el-col>
            <el-col :span="1"></el-col>
            <el-col :span="2">
              <el-button type="primary" @click="onForecast">预测</el-button>
            </el-col>
          </el-row>
        </div>
        <el-table
            :data="forecastResult"
            stripe
            border
            height="300">
          <el-table-column label="时间" prop="time"></el-table-column>
          <el-table-column label="预测值" prop="data"></el-table-column>
        </el-table>
        <template #footer>
            <span class="dialog-footer">
                <el-button type="primary" disabled>导出</el-button>
                <el-button type="primary" @click="forecastFittingOk('use')">应用</el-button>
                <el-button type="primary" @click="forecastFittingOk('ok')">确认</el-button>
            </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script>

import newChart from './chartConfig.vue'
import highchart from '@/components/Highchart.vue'
import axios from "axios"
import { ElMessage, ElMessageBox } from 'element-plus'
import DialogEx from "./dialogEx"
import moment from 'moment';
import BlockSelect from "@/components/blockSelect";

export default {
  name: "ChartView",
  props:[
    'templateInfo',
    'moduleManager', // 从模块管理打开
    'templateIndex'
  ],
  components: {
    highchart,
    newChart,
    DialogEx,
    BlockSelect
  },
  data() {
    let option = [];//options.chartOption
    return {
      loadingChaet:true,
      loading:true,
      info:{},//模板信息
      ddisable:true,
      changeConfigList:[],
      changeConfigNow:"",//修改配置页面选项初始值
      configModify:0,//配置修改标签
      switch_config_name:"",//切换配置页面单选框值
      save_config_name: "",//保存配置页的配置名称
      //changeConfigCode:1,//切换配置页面的单选框
      dialogVisible:false,
      changeDialogVisible:false,
      config_name:'',//图表配置的名称
      chartNum:0,
      subb:0,//子组件点击提交的状态
      obj:{},//传给子组件的数据
      jsons:[],//点击修改发给树的数据
      isShow:false,//新建图表页面的显示
      id: "chart_view",
      option: option,//chart的数据
      chartType: "normal",//chart的类型：normal、wellgroup
      viewDisplay: true, // 模块管理控制组件隐藏
      viewSelectionWell:false,//控制选井窗口隐藏
      selectionWellGroup:false,
      frameTime:null,//现在范围时间（年月）
      frameYear:{
        startTime: null,//开始时间
        endTime: null,//结束时间
      },//选择范围时间（年度）
      frameTimeType:"年月",//使用时间类型标识  年月，年。。。
      center_wells:[],//井组——中心井
      relation_wells:[],//井组——关联井
      wells:[],//单井——井名称信息

      gruponeCheckedWell:[],//井组1默认选中井
      gruptwoCheckedWell:[],//井组1默认选中井
      wellgroupOneData:[],//井列表
      wellgroupTwoData:[],//井列表
      relation_grup_list:[],//井组列表-当前用户井组及自定义选择模式
      relation_grupone_name:{},
      relation_gruptwo_name:{},

      wellgroupData:[],//接收左边栏井数据

      defaultProps: {
        children: 'children',
        label: 'label'
      },
      defcheckedBlk: [],//井组—关联井 默认勾选列
      defexpandBlk: [-1,0],//井组—关联井 默认展开列
      pageid:"",//页面id，保存系统配置时使用
      isPublicConfig:false,//保存模板时，用于判断是否是公用模板

      formOptions:null,//数据源列表
      dataUsrTree:null,//数据源列表（树形结构）
      isDataLoading:false,//下拉框数据源初始加载完成标识
      configLists:[],//获取配置界面的下拉列表数据
      isDefaultTemplate:false,//是否使用默认模板（页面配置表配置信息）标识

      dataBoxSelection:[],//框选数据
      viewBoxSelection:false,//拟合选值页面展示标识
      viewBoxForecast:false,//拟合预测页面展示标识
      fittingDatas:[],//拟合数据集
      fittingData:{},//单条拟合数据
      fittingDataNum:"",//单条拟合数据在数据集中序号
      IsSee:false,//查看标识
      fittingtype:[
        {
          label:"指数递减",
          data:"index"
        },
        {
          label:"双曲递减",
          data:"hyperbolic"
        },
        {
          label:"调和递减",
          data:"harmonic"
        },{
          label:"产量衰减",
          data:"decline"
        },{
          label:"线性递减",
          data:"linear"
        },
      ],//拟合 递减类型
      optionCopy: [],//初始配置(未进行绘制拟合曲线)
      optionFitting: [],//进行拟合曲线绘制后配置
      selectedChartIndex: 0,//选中对象对应序号(记录选中 坐标绘图的序号)
      isFitting:false,//是否支持拟合功能
      forecastData:{
        initialProduction:"0",//初始产量
        startTime: null,//开始时间
        endTime: null,//结束时间
      },//预测数据信息
      forecastIndex:0,//记录选取的拟合数据段位置信息，用于预测;默认使用第一个拟合数据段
      forecastResult:[],//预测结果
      forecastTableHeader:[
        {
          id:"time",
          name:"时间",
        },
        {
          id:"data",
          name:"产量",
        }
      ],//预测数据的对应表格表头信息
      forecastTableData:[],//预测数据的对应表格数据

      relations:{
        relation_grupone_name:"井组1",//井组1名称
        relation_grupone_wells:[],//井组1列表
        relations_grupone_checkedKeys:[],//勾选数据 id集合，用于打开时的数据勾选展示
        relation_gruptwo_name:"井组2",//井组2名称
        relation_gruptwo_wells:[],//井组2列表
        relations_gruptwo_checkedKeys:[],//勾选数据 id集合，用于打开时的数据勾选展示
      },//指标分析曲线的相关数据
      relation_grupone_filterText:"",//井组1检索文本
      relation_gruptwo_filterText:"",//井组2检索文本
      wellDataClickNum:0,//研究井位点击次数
      jsonUserInfo:{},//用户信息
      user_id:"0000001",//用户id
      curUserEmplyeeId:"",//用户empid
      app_id: "",//页面id
      token:"",//token
      WellTitles:[],//记录初始化的曲线标题名称
    }
  },
  mounted() {
    // 从模块管理打开，不加载初始配置
    if (this.moduleManager != null) {
      this.viewDisplay = false;
      return;
    }
    let userInfoSession = localStorage.getItem("lyqtUserInfo");
    if (userInfoSession == null) userInfoSession = {};
    if (userInfoSession.length > 0) {
      this.jsonUserInfo = JSON.parse(userInfoSession);
      this.user_id = this.jsonUserInfo.userId;
      this.curUserEmplyeeId = this.jsonUserInfo.employeeId;
    }
    this.app_id = this.templateInfo.pageid;
    this.token = localStorage.getItem("lyqtJwt");
    this.gettableSource();
    this.getConfig(true);
    //曲线（井组）类型
    console.log("abc",this.templateInfo.type)
    if (this.templateInfo.type=="chart_wellGroup"){
      this.$nextTick(() => {
        this.preSelectWellFunc();
        console.log("preRelatons",this.relations)
        this.wellsTimeConfig();
      });
    }


  },
  methods:{
    //查询数据源列表信息
    gettableSource(){
      this.formOptions=null;
      //获取下拉列表数据
      axios.get(process.env.VUE_APP_SERVER+"/dataprovider/systemdata/tableSource",{
        params: {
          user_id: this.user_id,
          app_id: this.app_id
        },}).then(res=>{
        this.formOptions=res.data.data;
        this.dataUsrTree=res.data.dataTree;
        console.log("数据源列表:",res.data);
      }).catch(err=>{
        console.log(err)
      })
    },
    //刪除模板
    changeConfigDel(){
      ElMessageBox.confirm(
          '你真的要删除这一行数据吗',
          'warning', {
            confirmButtonText:"确认",
            cancelButtonText:"取消",
            type:"warning"
          }
      ).then(()=>{
        let user_id = this.user_id;
        let switch_config_name = this.switch_config_name.replace("（用户）", "").replace("（公用）", "");
        if (this.switch_config_name.indexOf("（公用）") != -1)
          user_id = "0000001";
        axios.delete(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/chartConfig"+
            `?user_id=${user_id}&app_id=${this.app_id}&config_name=${switch_config_name}`)
            .then(res=>{
              console.log(res)
              ElMessage.success(res.data.message);
              this.clickSwitchConfig();

            })
      }).catch(err=>{
        console.log(err)
        ElMessage(err.data.message)
      })
    },
    //切换配置时当前配置无法删除
    changeConfig(){
      if(this.switch_config_name==this.changeConfigNow || this.switch_config_name == "defaultTemplate"){
        this.ddisable=true
      }else{
        this.ddisable=false
      }
    },

    //页面配置获取配置信息并展示
    queryTemplateConfig(pageid){
      console.log("moduleManager：",this.moduleManager);
      this.isDataLoading=false;//点击时，初始化标识信息
      this.loadingChaet=true;//点击时，添加加载效果
      //有前端有数据时直接赋值，无则后端查询数据
      if (this.moduleManager.template.length!=0){
        console.log("路线：",1);
        this.jsons=this.moduleManager.template;
        this.chartType=this.moduleManager.chartType;
        if(this.chartType == 'wellgroup'){
          this.$refs.blkSel.isShow.well = false;
          this.$refs.blkSel.well = "";
          // this.$refs.blkSel.select_grp_well("");
        }
        this.isFitting=this.moduleManager.isFitting;
        var obj ={};
        obj.type=0;
        obj.id=1;
        obj.code=0;
        obj.data=[];
        this.jsons.forEach(item=>{
          obj.data.push(item)
        })
        this.obj = obj;
        console.log("obj",this.obj);
      }
      else {
        console.log("路线：",2);
        axios({
          url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/queryConfig",
          method: 'POST',
          headers: {
            "Content-Type": "application/json"
          },
          data: {
            pageid: pageid
          }
        }).then((res) => {
          console.log("获取曲线数据：",res.data);
          if (res.data.template != null) {
            this.jsons=res.data.template;
            this.chartType=res.data.chartType;
            if(this.chartType == 'wellgroup'){
              this.$refs.blkSel.isShow.well = false;
              this.$refs.blkSel.well = "";
              // this.$refs.blkSel.select_grp_well("");
            }
            this.isFitting=res.data.isFitting;
            var obj ={};
            obj.type=0;
            obj.id=1;
            obj.code=0;
            obj.data=[];
            this.jsons.forEach(item=>{
              obj.data.push(item)
            })
            this.obj = obj;
            console.log("obj",this.obj);
          }
        }).catch((err) => {
          // alert('Error');
          console.log(err)
        })
      }
    },

    //单击修改模板按钮
    clickEditConfig(){
      this.isDataLoading=false;//点击时，初始化标识信息
      this.loadingChaet=true;//点击时，添加加载效果
      var jsons = this.$refs.highchart.getChartOptions();

      let configJson = [];
      if(this.chartType == "normal"){
        configJson = this.option;
        //如果存在拟合曲线，调用 optionCopy 配置
        if (this.isFitting)
          configJson = JSON.parse(JSON.stringify(this.optionCopy));//加载初始配置(未进行绘制拟合曲线)
      }
      else if(this.chartType == "wellgroup"){
        // let datasource = "";
        for(let index =0; index < jsons.length && index<2; index++){
            configJson.push(jsons[index]);
        }
      }
      this.jsons = configJson
      this.deleteWellTitle(this.jsons);
      console.log("jsons",configJson);
      //sessionStorage.setItem("jsons",this.jsons.toString());
      var obj ={};
      obj.type=0;
      obj.id=1;
      obj.code=0;
      obj.data=[];
      this.jsons.forEach(item=>{
        obj.data.push(item)
      })
      this.obj = obj;
      // console.log("obj",this.obj);
      this.clickNewConfig();
      // this.$nextTick(() => {
      //   this.$refs.newChart.changes(this.chartType);
      // });
    },
    /*  clickTree(data){
        var obj ={};
        obj.type=1;
        obj.id=data.id;
        obj.index=data.index;
        obj.code=data.code;
        obj.data=[];
        this.obj = obj;
      },*/
    //监听子组件提交状态
    sub(data){
      this.subb=data.code;
      if(this.subb==1){
        this.isShow=!this.isShow;
        document.body.style.overflow = "auto";
        this.configModify=0;
        this.$forceUpdate();
      }
      this.chartNum=data.chartNum;
    },
    //新建图表的确认提交
    submit(){
      this.fittingDatas=[];//清空拟合数据集
      this.$refs.newChart.submit(this.moduleManager);
    },
    //新建图表的返回
    goBack(){
      this.isShow=!this.isShow;
      // this.$refs.newChart.goBack();
      document.body.style.overflow = "auto";
      //返回时回置changeConfigNow
      this.changeConfigNow = this.config_name;
    },
    //新建图表
    clickNewConfig(){
      console.log("clickNewConfig", this.changeConfigNow, this.$refs.highchart.getChartConfigModifyFlag());
      // if(this.changeConfigNow!="" && this.$refs.highchart.getChartConfigModifyFlag() == true) {
      //   ElMessageBox.confirm(
      //     '当前曲线配置尚未保存，是否放弃当前修改?',
      //     '提醒',
      //     {
      //       confirmButtonText: '是',
      //       cancelButtonText: '否',
      //       type: 'warning',
      //     }
      //   )
      //     .then(() => {
      //       this.isShow=!this.isShow;
      //       document.body.style.overflow = "hidden";
      //       this.changeConfigNow = "";
      //       // this.config_name = "";
      //     })
      //     .catch(() => {
      //
      //     })
      // }
      // else{
      this.isShow=!this.isShow;
      document.body.style.overflow = "hidden";
      // this.changeConfigNow = "";
      // this.config_name = "";
      // }
    },
    //导出图像
    exportImage(command){
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      if (userInfoSession == null) userInfoSession = {};
      let curUserId = "";
      if (userInfoSession.length > 0) {
        let jsonUserInfo = JSON.parse(userInfoSession);
        curUserId = jsonUserInfo.userId == "" ? jsonUserInfo.employeeId : jsonUserInfo.userId;
      }
      let fileName = curUserId + "chart";
      this.$refs.highchart.exportImage(command, fileName);
    },
    //绘制图表
    drawChart(configOption, chartType){
      this.option = configOption;
      this.chartType = chartType;
      if(this.chartType == 'wellgroup'){
        this.$refs.blkSel.isShow.well = false;
        this.$refs.blkSel.well = "";
        // this.$refs.blkSel.select_grp_well("");
      }
    },
    //获取图表配置
    getConfig(init){
      this.loading=true;
      let _this = this;
      // let user_id = "0000001";
      // let app_id = this.templateInfo.pageid;
      // let userInfoSession = localStorage.getItem("lyqtUserInfo");
      // // console.log(userInfoSession);
      // if (userInfoSession == null) userInfoSession = {};
      // let curUserEmplyeeId = "";
      // if (userInfoSession.length > 0) {
      //   let jsonUserInfo = JSON.parse(userInfoSession);
      //   curUserEmplyeeId = jsonUserInfo.employeeId;
      // }
      // let token = localStorage.getItem("lyqtJwt");
      //初始化加载曲线数据获取localStorage中的井信息；

      let wells=JSON.parse(localStorage.getItem("wells"));
      if (wells!=null && wells.length==4){
        this.wells=wells;
      }
      //获取保存单井
      let blockSelectWells = JSON.parse(localStorage.getItem("blockSelectWells"));
      if (blockSelectWells != undefined && blockSelectWells != null && blockSelectWells.length == 1){
        this.wells=blockSelectWells;
      }
      if(this.$store.state.wellData.length!=0){
        _this.wellDataClickWithoutRefresh()
      }
      //如果是同一模块下切换页面，使用上个页面保留的时间
      if (this.$store.state.keepTime && this.$store.state.frameTime.length>0)
        this.frameTime=this.$store.state.frameTime;
      console.log('12ghshs：',this.chartType)
      this.getwellgroup();
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/chartConfigData",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        data:{
          user_id: this.user_id,
          user_empid: this.curUserEmplyeeId,
          app_id: this.app_id,
          token: this.token,
          // checkedBlk: this.curCheckedBlkId,
          // queryFilter: this.queryFilter,
          config_name: this.config_name,
          center_wells: _this.center_wells,
          wells: _this.relation_wells,
          wellSingle: _this.wells,
          time:this.frameTime,
          isDefaultTemplate: _this.isDefaultTemplate,
          chartType: _this.templateInfo.type,//曲线模板类型
          relations:this.relations,//井组数据（指标分析）
        }
      }).then(res=>{
        if(!init){
          ElMessage(res.data.message);
        }
        if(res.data.result != "success"){
          return;
        }
        _this.chartType = res.data.data.chart_type;
        if(_this.chartType == 'wellgroup'){
          _this.$refs.blkSel.isShow.well = false;
          _this.$refs.blkSel.well = "";
          // this.$refs.blkSel.select_grp_well("");
        }
        _this.option = res.data.data.config;
        // //标题拼接井号
        _this.option.index = this.templateIndex;
        this.getWellTitles(_this.option);
        this.splicingWellTitle(_this.option);
        _this.config_name = res.data.data.config_name;//测试行
        _this.changeConfigNow = res.data.data.config_name;
        _this.chartNum = _this.option.length;
        _this.configModify++;
        _this.chartType = res.data.data.chart_type;
        if(_this.chartType == 'wellgroup'){
          _this.$refs.blkSel.isShow.well = false;
          _this.$refs.blkSel.well = "";
          // this.$refs.blkSel.select_grp_well("");
        }
        let text=_this.option[0].title.text;
        _this.option[0].title.text=text;
        console.log("获取曲线配置:",res.data.data)
        console.log("res.data:",res.data)
        let a_type=res.data.data.config[0].xAxis.a_type;
        _this.frameTimeType=a_type;
        let len=res.data.data.config[0].xAxis.userCategory.length;
        if (a_type=="年月"||a_type=="年月日"){
          _this.frameTime=[res.data.data.config[0].xAxis.userCategory[0],res.data.data.config[0].xAxis.userCategory[len-1]];
        }else if (a_type=="年"){
          _this.frameYear.startTime=res.data.data.config[0].xAxis.userCategory[0];
          _this.frameYear.endTime=res.data.data.config[0].xAxis.userCategory[len-1];
        }
        _this.isDefaultTemplate=res.data.data.isDefaultTemplate;
        _this.$forceUpdate();
        this.optionCopy = JSON.parse(JSON.stringify(_this.option));//复制初始option（未进行绘制拟合曲线）
        this.isFitting = res.data.data.isFitting == "1" ? true : false;
      }).catch(err=>{
        console.log(err)
      });
    },
    //点击切换模板
    clickSwitchConfig(){
      let _this =this;
      axios({
        url: process.env.VUE_APP_SERVER + `/dataprovider/systemdata/chartConfigs?user_id=${this.user_id}&app_id=${this.app_id}`,
        method: "GET",
        data:{
          user_id:this.user_id,
          app_id:this.app_id
        }
      }).then(res=>{
        _this.changeConfigList=res.data.data;
        console.log("this.changeConfigList",_this.changeConfigList);
        if(_this.changeConfigList.length==0){
          ElMessage("您当前暂未保存任何配置")
          return
        }
        _this.switch_config_name = _this.changeConfigNow;
        console.log("changeConfigNow:",_this.changeConfigNow);
        this.changeDialogVisible = true;
        this.changeConfig();
      }).catch(err=>{
        console.log(err)
      });
    },
    //切换配置页面提交
    changeConfigOk() {
      if (this.switch_config_name == "defaultTemplate")
        this.isDefaultTemplate = true;
      else
        this.isDefaultTemplate = false;

      console.log("切换", this.config_name, this.changeConfigNow, this.$refs.highchart.getChartConfigModifyFlag());
      if (this.config_name == "" || this.$refs.highchart.getChartConfigModifyFlag() == true) {
        ElMessageBox.confirm(
            '当前曲线配置尚未保存，是否放弃当前修改?',
            '提醒',
            {
              confirmButtonText: '是',
              cancelButtonText: '否',
              type: 'warning',
            }
        )
            .then(() => {
              // ElMessage({
              //   type: 'success',
              //   message: '放弃编辑',
              // })
              this.switchConfig();
            })
            .catch(() => {
              // ElMessage({
              //   type: 'info',
              //   message: '继续编辑',
              // })
              this.changeDialogVisible = false;
            })
      } else {
        //切换模板时，初始化赋值，防止因为新模板不存在对应的图表导致的页面崩溃问题
        this.$refs.highchart.selectedChartIndex=0;
        this.switchConfig();
      }
    },
    //切换配置
    switchConfig(){
      this.changeDialogVisible=false;
      let _this = this;
      this.loading=true;
      this.selectionWellGroup=false;
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/chartConfigData",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        data: {
          user_id: this.user_id,
          user_empid: this.curUserEmplyeeId,
          app_id: this.app_id,
          token: this.token,
          config_name: this.switch_config_name,
          old_config_name: this.changeConfigNow,
          center_wells: this.center_wells,
          wells: _this.relation_wells,
          wellSingle: _this.wells,
          time:this.frameTime,
          isDefaultTemplate: _this.isDefaultTemplate,
          chartType: _this.templateInfo.type,//曲线模板类型
          relations:this.relations,//井组数据（指标分析）
        }
      }).then(res=>{
        console.log(res.data);
        //_this.config_name = _this.switch_config_name;
        _this.config_name = res.data.data.config_name;
        _this.option = res.data.data.config;
        //标题拼接井号
        _this.option.index = this.templateIndex;
        this.getWellTitles(_this.option);
        this.splicingWellTitle(_this.option);
        _this.chartNum = _this.option.length;
        _this.configModify++;
        _this.changeConfigNow=res.data.data.config_name;
        _this.chartType = res.data.data.chart_type;
        if(_this.chartType == 'wellgroup'){
          _this.$refs.blkSel.isShow.well = false;
          _this.$refs.blkSel.well = "";
          // this.$refs.blkSel.select_grp_well("");
        }
        let len=res.data.data.config[0].xAxis.userCategory.length;
        _this.frameTime=[res.data.data.config[0].xAxis.userCategory[0],res.data.data.config[0].xAxis.userCategory[len-1]];
        _this.isDefaultTemplate=res.data.data.isDefaultTemplate;
        // _this.$forceUpdate();

        this.optionCopy=JSON.parse(JSON.stringify(this.option));//复制初始option（未进行绘制拟合曲线
        this.isFitting = res.data.data.isFitting == "1" ? true : false;
      }).catch(err=>{
        console.log(err)
      });
    },
    //配置另存为
    clickSaveAsConfig(){
      this.isPublicConfig=false;
      this.save_config_name = this.changeConfigNow.replace("（用户）", "").replace("（公用）", "");
      if (this.changeConfigNow == "defaultTemplate")
        this.save_config_name = "";
      this.dialogVisible = true;
    },
    //保存配置
    clickSaveConfig(){
      this.save_config_name = "";
      //保存配置时，如果使用的是系统默认模板，则需填写配置名称
      if (this.changeConfigNow == "defaultTemplate")
        this.clickSaveAsConfig()
      else
        this.postman();
    },
    //输入配置名称页面的提交
    configNameOk(){
      if (this.save_config_name == "") {
        ElMessage("请填写配置名称");
        return
      }
      this.postman();
      this.dialogVisible = false;
    },
    //配置的异步提交
    postman(){
      let config_name = "";
      // 另存系统配置  or 另存配置(另存公用配置)  or 保存配置
      if (this.pageid != "") {
        config_name = "defaultTemplate";
        this.changeConfigNow = "defaultTemplate";
      }
      else if (this.save_config_name != "") {
        config_name = this.save_config_name;
        this.changeConfigNow = config_name + "（用户）";
        if( this.isPublicConfig==true){
          this.changeConfigNow = config_name + "（公用）";
        }
      }
      else {
        config_name = this.changeConfigNow.replace("（用户）", "").replace("（公用）", "");
        this.changeConfigNow = config_name + "（用户）";
      }
      console.log("-------------------------")
      console.log(config_name)
      console.log(this.changeConfigNow)

      //保存时清空数据
      let optionDatasource = [];
      let option = this.option.slice(0);//配置信息
      this.deleteWellTitle(option);
      console.log("option",option);
      for(let index=0; index<option.length; index++){
        for(let index_series=0; index_series<option[index].series.length; index_series++){
          option[index].series[index_series].data = [];//保存配置前先清空数据
        }
        optionDatasource.push(option[index].a_dataSource);
        option[index].xAxis.userCategory = [];//清空x轴数据F
      }
      let wellgroup_option = [];//获取井组曲线配置
      if(this.chartType == "wellgroup"){
        //将数据源去重
        // let hash=[];
          for (let index = 0; index < option.length && index<2; index++) {
              wellgroup_option.push(option[index]);
          }
        option=wellgroup_option;
      }
      let user_id = this.isPublicConfig ? "0000001" : this.user_id;
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/chartConfig",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        data: {
          user_id: user_id,
          app_id: this.app_id,
          config_name: config_name,
          config: option,
          config_type: this.chartType,
          pageid: this.pageid,
          isFitting: this.isFitting ? "1" : "0",
        }
      }).then(res=>{
        ElMessage(res.data.message);
        console.log(res);
        this.configModify++;
      }).catch(err=>{
        console.log(err)
        ElMessage(err.data.message)
      });
    },
    //选则时间段后触发（年月）
    selectTime(val){
      let _this=this
      if (val != null) {
        _this.wellsTimeConfig();
      }
    },
    //选则时间段后触发（年度）
    selectYear(val,type){
      console.log("frameYear:",this.frameYear);
      if (type == "start")
        this.frameYear.startTime = val;
      else
        this.frameYear.endTime = val;
      //选择时间段后触发，将时间数据赋值给frameTime变量，调用处理函数
      if (this.frameYear.startTime!=null && this.frameYear.endTime!=null) {
        let time = [];
        time.push(this.frameYear.startTime);
        time.push(this.frameYear.endTime);
        this.frameTime = time;
        // this.wellsTimeConfig();
      }
      //不选择时间
      if (this.frameYear.startTime==null && this.frameYear.endTime==null){
        let time = [];
        time.push(this.frameYear.startTime);
        time.push(this.frameYear.endTime);
        this.frameTime = time;
      }
    },
    //获取勾选井组1—关联井数据
    handleWellCheckOne(currentNode, checkedObjs) {
      let wellGrupOneData = [];
      let checkednodes = checkedObjs.checkedNodes;
      for (let nodeIdx in checkedObjs.checkedNodes) {
        let data = checkednodes[nodeIdx];
        //判断是否是最小的节点
        if (!data.children) {
          //获取井名称
          wellGrupOneData.push(data.label);
        }
      }
      this.relations.relation_grupone_wells = wellGrupOneData;
      this.relations.relations_grupone_checkedKeys = checkedObjs.checkedKeys;
    },

    //获取勾选井组2—关联井数据
    handleWellCheckTwo(currentNode, checkedObjs) {
      let wellGrupTwoData = [];
      let checkednodes = checkedObjs.checkedNodes;
      for (let nodeIdx in checkedObjs.checkedNodes) {
        let data = checkednodes[nodeIdx];
        //判断是否是最小的节点
        if (!data.children) {
          //获取井名称
          wellGrupTwoData.push(data.label);
        }
      }
      this.relations.relation_gruptwo_wells = wellGrupTwoData;
      this.relations.relations_gruptwo_checkedKeys = checkedObjs.checkedKeys;
    },
    //选择井，与时间时调用，不重新读取配置，提交当前页面配置查询
    async wellsTimeConfig() {
      this.loading = true;
      this.viewSelectionWell = false;
      this.selectionWellGroup = false;
      // let user_id = "0000001";
      // let app_id = this.templateInfo.pageid;
      //
      // let userInfoSession = localStorage.getItem("lyqtUserInfo");
      // // console.log(userInfoSession);
      // if (userInfoSession == null) userInfoSession = {};
      // let curUserEmplyeeId = "";
      // if (userInfoSession.length > 0) {
      //   let jsonUserInfo = JSON.parse(userInfoSession);
      //   curUserEmplyeeId = jsonUserInfo.employeeId;
      // }
      let chartOptionType = this.chartType;
      let configJson = [];//获取曲线配置，井组则过滤多余配置
      //let token = localStorage.getItem("lyqtJwt");


      if(this.templateInfo!=undefined && this.templateInfo.type=='chart_wellGroup'){
        await this.preSelectWellFunc();
      }
      console.log("23456",this.relations,this.wells)
      if (chartOptionType == "normal") {
        configJson = this.option;
        //如果存在拟合曲线，调用 optionCopy 配置
        if (this.isFitting)
          configJson = JSON.parse(JSON.stringify(this.optionCopy));//加载初始配置(未进行绘制拟合曲线)
      }
      else if(chartOptionType == "wellgroup"){
        // let datasource = "";
        for (let index = 0; index < this.option.length && index<2; index++) {
            configJson.push(this.option[index]);
        }
      }
      console.log("234567",this.relations)
      this.deleteWellTitle(configJson);
      if(chartOptionType == "wellgroup") {
        this.$refs.blkSel.well = ""
        this.$refs.blkSel.select_grp_well("");
        this.getwellgroup();
      }
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/chartOptions",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        data: {
          user_id: this.user_id,
          user_empid: this.curUserEmplyeeId,
          app_id: this.app_id,
          chartOptionType: chartOptionType,
          chartOption: configJson,
          token: this.token,
          center_wells: this.center_wells,
          wells: this.relation_wells,
          wellSingle: this.wells,
          time: this.frameTime,
          chartType: this.templateInfo.type,//曲线模板类型
          relations:this.relations,//井组数据（指标分析）
        }
      }).then(res => {
        if (res.status == 200) {
          if (res.data.result == "success") {
            this.splicingWellTitle(res.data.data);
            this.optionCopy = JSON.parse(JSON.stringify(res.data.data));//复制初始option（未进行绘制拟合曲线
            console.log(res.data);
            this.drawChart(res.data.data, chartOptionType);
          }
        }
      }).catch(err => {
        console.log(err)
      });
    },

    //获取曲线标题的初始化名称
    getWellTitles(config) {
      this.WellTitles = [];
      for (let i = 0; i < config.length; i++) {
        let textName = config[i].title.text;
        textName = textName.replace("[对象]", "");//todo 为适配以前保存配置，替换对应字符
        this.WellTitles.push(textName);
      }
    },
    //曲线标题拼接井号
    splicingWellTitle(config) {
      //未勾选区块信息时，初始化加载，wells为空，暂不拼接；
      if (this.wells.length == 0)
        return
      for (let i = 0; i < config.length; i++) {
        if (this.chartType == "normal") {
          config[i].title.text = this.wells[0] + this.WellTitles[i];
        }
        else {
          if (i == 0)
            config[i].title.text = (this.center_wells.length != 0 ? this.center_wells[0] : "") + this.WellTitles[0];
          else
            config[i].title.text = (this.relation_wells.length != 0 ? this.relation_wells[i - 1] : "") + this.WellTitles[1];
        }
      }
      return config;
    },
    //曲线标题删除井号
    deleteWellTitle(config) {
      console.log(this.WellTitles);
      for (let i = 0; i < config.length; i++) {
        config[i].title.text = this.WellTitles[i];
      }
      return config;
    },

    //点击选井按钮
    clickSelectionWell(){
      this.viewSelectionWell = true;
      this.wellgroupData=this.$store.getters.getWellgroupData;
      this.$nextTick(() => {
        this.$refs.centerWellTree.setCurrentKey(this.center_wells[0]);
      })
      console.log(this.wellgroupData);
    },
    //点击选井按钮（指标分析）
    celectionWellGroup() {
      this.selectionWellGroup = true;
      // this.wellgroupData=this.$store.getters.getWellgroupData;
      // console.log(this.wellgroupData);
      this.preSelectWellFunc();
    },
    async preSelectWellFunc(){
      await this.getUserBlockData();

      //获取区块o类型
      let blkTypeId = localStorage.getItem("blockType");
      if (blkTypeId == null || blkTypeId == undefined) blkTypeId = "02";//01一期区块 02银行地质单元 03 计划区块

      if(blkTypeId=="04"){//井组则自动设置当前选定井组
        let checkedBlock = localStorage.getItem("checkedBlock");//左侧勾选区块信息
        if (checkedBlock == null) {
          checkedBlock = {};
        }
        let jsonCheckedBlk;
        try {
          jsonCheckedBlk = JSON.parse(checkedBlock);
        } catch {
          jsonCheckedBlk = JSON.parse("{}");
        }
        console.log("checkeBlkCnt",this.relation_grup_list)
        if(Object.keys(jsonCheckedBlk).length>=2) {
          let grupIdx = 0;
          for (let grupID in jsonCheckedBlk) {
            if (grupIdx == 0) {
              this.relation_grupone_name = grupID
              await this.onRelationGroupOneChange(grupID);
            } else if (grupIdx == 1) {
              this.relation_gruptwo_name = grupID
              await this.onRelationGroupTwoChange(grupID);
            } else {
              break;
            }
            grupIdx += 1;
          }

          this.relations.relation_grupone_name = "井组1";
          this.relations.relation_gruptwo_name = "井组2";
          for (let grupIdx = 0; grupIdx < this.relation_grup_list.length; grupIdx++) {
            if (this.relation_grup_list[grupIdx].value == this.relation_grupone_name) {
              this.relations.relation_grupone_name = this.relation_grup_list[grupIdx].label;
            }
            if (this.relation_grup_list[grupIdx].value == this.relation_gruptwo_name) {
              this.relations.relation_gruptwo_name = this.relation_grup_list[grupIdx].label;
            }
          }
        }
        else{
          //指标分析相关曲线井组数据获取
          let relations=JSON.parse(localStorage.getItem("relations"));
          if (relations!=null){
            this.relations.relation_grupone_name=relations.relation_grupone_name;
            this.relations.relation_grupone_wells=relations.relation_grupone_wells;
            this.relations.relations_grupone_checkedKeys=relations.relations_grupone_checkedKeys;
            this.relations.relation_gruptwo_name=relations.relation_gruptwo_name;
            this.relations.relation_gruptwo_wells=relations.relation_gruptwo_wells;
            this.relations.relations_gruptwo_checkedKeys=relations.relations_gruptwo_checkedKeys;
            for (let grupIdx = 0; grupIdx < this.relation_grup_list.length; grupIdx++) {
              if (this.relation_grup_list[grupIdx].label == this.relations.relation_grupone_name) {
                this.relation_grupone_name = this.relation_grup_list[grupIdx].value;
              }
              if (this.relation_grup_list[grupIdx].label == this.relations.relation_gruptwo_name) {
                this.relation_gruptwo_name = this.relation_grup_list[grupIdx].value;
              }
            }
            if(this.wellgroupOneData.length == 0) {await this.onRelationGroupOneChange(this.relation_grupone_name);}
            if(this.wellgroupTwoData.length == 0) {await this.onRelationGroupTwoChange(this.relation_gruptwo_name);}
          }
          else{
            this.wellgroupOneData=this.$store.getters.getWellgroupData;
            this.wellgroupTwoData=this.$store.getters.getWellgroupData;
            this.relation_grupone_name = "auto";
            this.relation_gruptwo_name = "auto";
          }
        }
      }
      else{
        //指标分析相关曲线井组数据获取
        let relations=JSON.parse(localStorage.getItem("relations"));
        if (relations!=null){
          this.relations.relation_grupone_name=relations.relation_grupone_name;
          this.relations.relation_grupone_wells=relations.relation_grupone_wells;
          this.relations.relations_grupone_checkedKeys=relations.relations_grupone_checkedKeys;
          this.relations.relation_gruptwo_name=relations.relation_gruptwo_name;
          this.relations.relation_gruptwo_wells=relations.relation_gruptwo_wells;
          this.relations.relations_gruptwo_checkedKeys=relations.relations_gruptwo_checkedKeys;
          for (let grupIdx = 0; grupIdx < this.relation_grup_list.length; grupIdx++) {
            if (this.relation_grup_list[grupIdx].label == this.relations.relation_grupone_name) {
              this.relation_grupone_name = this.relation_grup_list[grupIdx].value;
            }
            if (this.relation_grup_list[grupIdx].label == this.relations.relation_gruptwo_name) {
              this.relation_gruptwo_name = this.relation_grup_list[grupIdx].value;
            }
          }
          if(this.wellgroupOneData.length == 0) {await this.onRelationGroupOneChange(this.relation_grupone_name);}
          if(this.wellgroupTwoData.length == 0) {await this.onRelationGroupTwoChange(this.relation_gruptwo_name);}
        }
        else{
          this.wellgroupOneData=this.$store.getters.getWellgroupData;
          this.wellgroupTwoData=this.$store.getters.getWellgroupData;
          this.relation_grupone_name = "auto";
          this.relation_gruptwo_name = "auto";
        }
      }
    },
    //获取用户权限区块
    async getUserBlockData(){
      let _this = this;
      _this.relation_grup_list=[];
      let lyqtUserInfo = JSON.parse(localStorage.getItem("lyqtUserInfo"));
      //this.wellDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/userWellData";
      let blkDataUrl=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/userBlockData"+`?userId=${lyqtUserInfo.userId}`;
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (jwtSession == null) jwtSession = "";
      await axios({
        url: blkDataUrl,
        headers: {
          "Authorization": "Bearer " + jwtSession
        },
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          _this.relation_grup_list = res.data[0].children;
          _this.relation_grup_list.push({value:"auto",label:"自定义选择"});
          console.log("区块：",_this.relation_grup_list);
        }
      }).catch((err) => {
        // alert('Error');
        _this.relation_grup_list.push({value:"auto",label:"自定义选择"});
        console.log(err)
      })
    },
    async onRelationGroupOneChange(val){
      console.log("当前选择井组1",val)
      this.gruponeCheckedWell = []
      this.relation_grupone_wells = []
      this.relations.relations_grupone_checkedKeys = []
      this.relations.relation_grupone_wells = []
      this.wellgroupOneData=[]
      this.relations.relation_grupone_name = "井组1";
      if(val == "auto"){
        this.$nextTick(() => {
          this.wellgroupOneData=this.$store.getters.getWellgroupData;
        })
      }
      else{
        await this.getUserWellData(val);
        for (let grupIdx = 0; grupIdx < this.relation_grup_list.length; grupIdx++) {
          if (this.relation_grup_list[grupIdx].value == this.relation_grupone_name) {
            this.relations.relation_grupone_name = this.relation_grup_list[grupIdx].label;
          }
        }
      }

    },
    //获取井数据
    async getUserWellData(wellGrpID) {
      let that = this;
      let wellDataUrl = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/userWellData";
      let wellGrpObj = {}
      wellGrpObj[wellGrpID] = wellGrpID;
      await axios({
        url: wellDataUrl,
        method: 'POST',
        headers: {"Content-Type": "application/json"},
        data: wellGrpObj
      }).then((res) => {
        if (res.status === 200) {
          that.wellgroupOneData = res.data;
          if(this.wellgroupOneData != undefined && this.wellgroupOneData != null){
            this.setCheckWells(this.wellgroupOneData)
          }
          else {
            that.wellgroupOneData = []
          }
        }
        that.loading = false;
      }).catch((err) => {
        console.log(err)
        that.wellgroupOneData = []
      })
    },
    async onRelationGroupTwoChange(val){
      console.log("当前选择井组2",val)
      this.gruptwoCheckedWell = []
      this.relation_gruptwo_wells = []
      this.wellgroupTwoData=[]
      this.relations.relations_gruptwo_checkedKeys = []
      this.relations.relation_gruptwo_wells = []
      this.relations.relation_gruptwo_name = "井组2";
      if(val == "auto"){
        this.$nextTick(() => {
          this.wellgroupTwoData=this.$store.getters.getWellgroupData;
        })
      }
      else{
        await this.getGrupTwoWellData(val);
        for (let grupIdx = 0; grupIdx < this.relation_grup_list.length; grupIdx++) {
          if (this.relation_grup_list[grupIdx].value == this.relation_gruptwo_name) {
            this.relations.relation_gruptwo_name = this.relation_grup_list[grupIdx].label;
          }
        }
      }

    },
    //获取井数据
    async getGrupTwoWellData(wellGrpID) {
      let that = this;
      let wellDataUrl = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/userWellData";
      let wellGrpObj = {}
      wellGrpObj[wellGrpID] = wellGrpID;
      await axios({
        url: wellDataUrl,
        method: 'POST',
        headers: {"Content-Type": "application/json"},
        data: wellGrpObj
      }).then((res) => {
        if (res.status === 200) {
          that.wellgroupTwoData = res.data;
          if(this.wellgroupTwoData != undefined && this.wellgroupTwoData != null){
            this.setGrupTwoCheckWells(this.wellgroupTwoData)
            console.log("Grup2Wells:",this.relation_gruptwo_wells)
          }
          else {
            that.wellgroupTwoData = []
          }
        }
        that.loading = false;
      }).catch((err) => {
        console.log(err)
        that.wellgroupTwoData = []
      })
    },
    setCheckWells(wellNodes){
      for(let i=0;i<wellNodes.length;i++){
        let wellNode = wellNodes[i];
        if(wellNode.children == null || wellNode.children == undefined){
          // this.gruponeCheckedWell.push(wellNode.id);
          // this.relation_grupone_wells.push(wellNode.label);
          this.relations.relations_grupone_checkedKeys.push(wellNode.id);
          this.relations.relation_grupone_wells.push(wellNode.label);
        }
        else{
          this.setCheckWells(wellNode.children);
        }
      }
    },
    setGrupTwoCheckWells(wellNodes){
      for(let i=0;i<wellNodes.length;i++){
        let wellNode = wellNodes[i];
        if(wellNode.children == null || wellNode.children == undefined){
          // this.gruptwoCheckedWell.push(wellNode.id);
          // this.relation_gruptwo_wells.push(wellNode.label);
          this.relations.relations_gruptwo_checkedKeys.push(wellNode.id);
          this.relations.relation_gruptwo_wells.push(wellNode.label);
        }
        else{
          this.setGrupTwoCheckWells(wellNode.children);
        }
      }
    },


    //过滤井节点，根据输入的井号对比过滤
    filterWellNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //获取井节点图标
    getWellNodeIcon(data, node){
      let jbStr = node.data.MQJB;
      if(jbStr != "采油井" && jbStr != "采气井" && jbStr != "注水井" && jbStr != "注气井")
        jbStr = "井";
      return "/"+jbStr+".png"
    },
    //获取选中井组—中心井数据
    handleWellCheckChange(data) {
      this.center_wells = [];
      //单击单井信息,点击井分类默认获取分类下的第一口井
      if (!data.children) {
        this.center_wells.push(data.label);
      }
      else if (!data.children[0].children) {
        this.center_wells.push(data.children[0].label);
      }
      else {
        this.center_wells.push(data.children[0].children[0].label);
      }
      console.log(this.center_wells);
    },
    //获取勾选井组—关联井数据
    handleCheckChange(currentNode, checkedObjs) {
      // console.log("currentNode:", currentNode);
      // console.log("checkedObjs", checkedObjs);
      let wellData=[];
      let checkednodes = checkedObjs.checkedNodes;
      for (let nodeIdx in checkedObjs.checkedNodes)
      {
        let data = checkednodes[nodeIdx];
        //判断是否是最小的节点
        if (!data.children){
          //获取井名称
          wellData.push(data.label);
        }
      }
      this.relation_wells=wellData;
      console.log("wellData:",this.relation_wells);
    },

    //另存系统配置
    clickSaveSystemConfig(){
      this.isPublicConfig=false;
      this.pageid=this.templateInfo.pageid;
      this.postman();
      this.pageid="";
    },
    //另存公用配置
    clickSavepublicConfig(){
      this.isPublicConfig = true;
      this.dialogVisible = true;
    },

    //获取配置界面的下拉列表数据 todo
    getConfigList(){
      //获取下拉列表数据
      axios.get(process.env.VUE_APP_SERVER+"/dataprovider/systemdata/tableSource",{
        params: {
          user_id: this.user_id,
          app_id:this.app_id
        },
      }).then(res=>{
        this.configLists=res.data;
        console.log("configLists",res.data);
      }).catch(err=>{
        console.log(err)
      })
    },

    //拟合选值展示框，数据勾选状态改变时触发
    dataBoxSelectionChange(val){
      this.fittingData={};
      if (val.length==0 || val==[]){
        return ;
      }
      //判断是否是查看数据
      if (!this.IsSee) {
        this.fittingData.name = "拟合数据段0";
        this.fittingData.type = "index";
        this.fittingData.Q0 = "";
        this.fittingData.ai = "";
        this.fittingData.n = "";
        this.fittingData.a = "";
        this.fittingData.r = "";
        this.fittingData.formular = "";
      }
      else {
        this.fittingData.name = this.fittingDatas[this.fittingDataNum].name;
        this.fittingData.type = this.fittingDatas[this.fittingDataNum].type;
        this.fittingData.Q0 = this.fittingDatas[this.fittingDataNum].Q0
        this.fittingData.ai = this.fittingDatas[this.fittingDataNum].ai;
        this.fittingData.n = this.fittingDatas[this.fittingDataNum].n;
        this.fittingData.a = this.fittingDatas[this.fittingDataNum].a;
        this.fittingData.r = this.fittingDatas[this.fittingDataNum].r;
        this.fittingData.formular = this.fittingDatas[this.fittingDataNum].formular;
      }
      let dataBoxSelection=JSON.parse(JSON.stringify(this.dataBoxSelection));
      console.log("skhdjbdjbddb");
      console.log(dataBoxSelection);
      let rangeData= [];//按照时间顺序 日期范围内的数据信息
      let t= [];//相对日期数组
      let relativeT=0;//记录勾选数据个数
      let initialDate="";//初始日期，默认勾选数据的第一个，也是最早的日期。
      //循环所有日期数据
      for (let i=0;i<dataBoxSelection.length;i++){
        dataBoxSelection[i].selected=false;//默认赋值
        //循环勾选数据，有相同日期时，则标识值：true
        for (let j=0;j<val.length;j++){
          if (dataBoxSelection[i].name==val[j].name){
            dataBoxSelection[i].selected=true;
            break;
          }
        }
        let rangeDataOne={};
        //如果是勾选数据，则计算相对时间
        if (dataBoxSelection[i].selected==true){
          if (relativeT==0){
            this.fittingData.start = dataBoxSelection[i].name;//赋值 开始时间
            initialDate=dataBoxSelection[i].name.toString();//记录初始日期
          }
          rangeDataOne.name=dataBoxSelection[i].name;
          rangeData.push(rangeDataOne);
          //获取年份的相对值
          t.push((dataBoxSelection[i].name.substring(0,4)-initialDate.substring(0,4))*12+(dataBoxSelection[i].name.substring(4,6)-initialDate.substring(4,6)));
          relativeT++;
          if (relativeT==val.length){
            this.fittingData.end = dataBoxSelection[i].name;//赋值 结束时间
          }
        }
        //把日期范围内的其他为勾选数据也添加进 t 和 rangeData
        if(relativeT>0&&relativeT<val.length&&dataBoxSelection[i].selected!=true){
          rangeDataOne.name=dataBoxSelection[i].name;
          rangeData.push(rangeDataOne);
          //获取年份的相对值
          t.push((dataBoxSelection[i].name.substring(0,4)-initialDate.substring(0,4))*12+(dataBoxSelection[i].name.substring(4,6)-initialDate.substring(4,6)));
        }
      }
      this.fittingData.dataAll =dataBoxSelection;
      this.fittingData.selectData = rangeData;
      this.fittingData.t = t;
      // console.log("fittingData:", this.fittingData);
    },
    //拟合选值展示框，确定
    dataBoxSelectionOk(){
      let fittingData=JSON.parse(JSON.stringify(this.fittingData));
      //判断是否是查看，是——修改数据；不是——添加数据
      if (!this.IsSee){
        //修改拟合数据段名称
        let name=fittingData.name;
        fittingData.name=name.substring(0,name.length-1)+(this.fittingDatas.length+1);
        this.fittingDatas.push(fittingData);
      }else {
        this.fittingDatas[this.fittingDataNum]=fittingData;
      }
      this.viewBoxSelection=false;
      console.log(this.fittingDatas);
    },
    //拟合数据——查看
    onFittingDataSee(index,row){
      console.log(index,row);
      this.fittingDataNum=index;
      this.dataBoxSelection=row.dataAll;
      this.viewBoxSelection=true;
      this.IsSee=true;
      //延时勾选所有数据
      setTimeout(()=>{
        // this.$refs.multipleTableRef.clearSelection();//清空勾选状态
        for (let i=0;i<this.dataBoxSelection.length;i++){
          if (this.dataBoxSelection[i].selected==true){
            this.$refs.multipleTableRef.toggleRowSelection(this.dataBoxSelection[i],true);//切换勾选数据的勾选状态
          }
        }
      },100)
    },
    //拟合数据——删除
    onFittingDataDelete(index,row){
      console.log(index,row);
      this.fittingDatas.splice(index,1);
    },
    //拟合——拟合数据
    onFitting(){
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/exp/fittingTransfer",
        method:"post",
        headers:{
          "Content-Type": "application/json"
        },
        data:{
          fittingDatas:this.fittingDatas
        }
      }).then((res)=>{
        console.log(res);
        //将查询拟合相关数据赋给对应拟合数据段
        if (res.data.length>0){
          console.log("copy:",this.optionCopy);
          for (let i=0;i<res.data.length;i++){
            this.fittingDatas[i].a=res.data[i].a;
            this.fittingDatas[i].ai=res.data[i].ai;
            this.fittingDatas[i].Q0=res.data[i].Q0;
            this.fittingDatas[i].n=res.data[i].n;
            this.fittingDatas[i].r=res.data[i].r;
            this.fittingDatas[i].formular=res.data[i].formular;
          }

          //获取复制曲线配置信息(未进行绘制拟合曲线)
          let  option=JSON.parse(JSON.stringify(this.optionCopy));
          let series=option[this.selectedChartIndex].series;//获取选中曲线的series绘制信息，一条数据代表一条曲线。
          //根据拟合数据段的个数添加对应曲线绘制信息
          for (let i=0;i<res.data.length;i++){
            //复制单条曲线绘制信息，所有拟合数据曲线，都在此变量上修改
            let  seriesOne=JSON.parse(JSON.stringify(series[0]));
            seriesOne.id="fitting"+i;
            seriesOne.name=this.fittingDatas[i].name;//修改曲线名称
            seriesOne.dataLabels.enabled=false;//隐藏标签
            seriesOne.marker.enabled=false;//隐藏点
            seriesOne.color="#FF0000";//曲线颜色

            //封装拟合数据的data信息
            let result=res.data[i].result;//获取调用拟合接口查询的结果
            let data=seriesOne.data;
            for (let j=0;j<data.length;j++){
              if (data[j][0] in result){
                data[j][1]=parseFloat(result[data[j][0]]);
              }else {
                data[j][1]=null;
              }
            }
            series.push(seriesOne);//添加对应拟合数据段的曲线绘制信息
          }
          this.option=option;
          this.drawChart(this.option,this.chartType);
          this.optionFitting=JSON.parse(JSON.stringify(option));//保存拟合曲线绘制后配置
        }

      }).catch((err)=>{
        alert("Error");
        console.log(err);
      })
    },
    //清除绘制曲线——拟合数据
    emptyFitting(){
      this.option = JSON.parse(JSON.stringify(this.optionCopy));//加载初始配置(未进行绘制拟合曲线)
      this.optionFitting=JSON.parse(JSON.stringify(this.optionCopy));//保存拟合曲线绘制后配置
    },
    //预测按钮——拟合数据
    forecastFitting(){
      console.log(this.fittingDatas);
      if (this.fittingDatas.length==0){
        ElMessage("请添加拟合数据");
        return ;
      }
      if (this.forecastData.startTime == null) {
        //根据x时间轴的最后一个日期，默认获取预测开始日期
        let startTime = new Date();
        let len = this.fittingDatas[0].dataAll.length;
        let time = this.fittingDatas[0].dataAll[len - 1].name;
        startTime.setFullYear(time.substr(0, 4));
        startTime.setMonth(time.substr(4, 2));
        this.forecastData.startTime = startTime;
        console.log("startTime:", startTime);
      }
      this.viewBoxForecast=true;
    },
    //预测按钮——产量预测页面
    onForecast(){
      if(this.forecastData.startTime==null || this.forecastData.endTime==null){
        ElMessage("请补全信息");
        return ;
      }
      console.log("forecastData:",this.forecastData);
      //时间选择开始月份，需加上一个月
      if (this.forecastData.startTime.toLocaleTimeString() == "00:00:00")
        this.forecastData.startTime.setMonth(this.forecastData.startTime.getMonth() + 1);//传递到后台后，月份差一个月，提前加上
      this.forecastData.endTime.setMonth(this.forecastData.endTime.getMonth()+1);//传递到后台后，月份差一个月，提前加上
      axios({
        url:process.env.VUE_APP_SERVER + "/dataprovider/systemdata/exp/forecastoutput",
        method:"post",
        headers:{
          "Content-Type": "application/json"
        },
        data:{
          forecastData:this.forecastData,
          fittingData:this.fittingDatas[this.forecastIndex]
        }
      }).then(res=>{
        console.log(res);
        if (this.forecastData.startTime.toLocaleTimeString() == "00:00:00")
          this.forecastData.startTime.setMonth(this.forecastData.startTime.getMonth() - 1);//后台计算完成后，将补的一个月再减去
        this.forecastData.endTime.setMonth(this.forecastData.endTime.getMonth()-1);//后台计算完成后，将补的一个月再减去
        if (res.data.length==0){
          return ;
        }
        this.forecastResult=[];
        for (let i=0;i<res.data.length;i++){
          // if(Object.keys(res.data[i]).length>0){
          //   let firstPt = {};
          //   let dataAll = this.fittingDatas[this.forecastIndex].dataAll;
          //   let lastDatObj = dataAll[dataAll.length-1];
          //   firstPt.time = lastDatObj.name;
          //   firstPt.data = lastDatObj.y;
          //   this.forecastResult.push(firstPt);
          // }
          for(let j=0;j<Object.keys(res.data[i]).length;j++){
            let result={};
            result.time=Object.keys(res.data[i])[j];
            result.data = parseFloat(this.forecastData.initialProduction);
            result.data=(result.data+res.data[i][result.time]).toFixed(2);
            this.forecastResult.push(result);
          }
          console.log("forecastResult:",this.forecastResult);
        }
      }).catch(err=>{
        this.forecastData.endTime.setMonth(this.forecastData.endTime.getMonth()-1);//后台计算完成后，将补的一个月再减去
        alert("Error_onForecast");
        console.log(err);
      })
    },
    //预测确定，应用——拟合数据
    forecastFittingOk(val){
      if (this.forecastResult==[] || this.forecastResult.length==0){
        ElMessage("请先进行预测");
        return
      }
      //获取复制曲线配置信息(进行拟合曲线绘制后配置), todo 目前存在一种情况，框选数据后不进行拟合就预测，optionFitting为空
      let  option= this.optionFitting.length==0 ? JSON.parse(JSON.stringify(this.optionCopy)) : JSON.parse(JSON.stringify(this.optionFitting));
      let series=option[this.selectedChartIndex].series;//获取选中曲线的series绘制信息，一条数据代表一条曲线。
      let xAxis=option[this.selectedChartIndex].xAxis;//获取选中曲线的xAxis信息，代表曲线的x轴配置信息。
      //复制单条曲线绘制信息，预测数据曲线，都在此变量上修改
      let  seriesOne=JSON.parse(JSON.stringify(series[0]));
      seriesOne.id="forecast";
      seriesOne.name="预测曲线";//修改曲线名称
      seriesOne.color="#1cac79";//曲线颜色
      //封装预测数据的data信息
      let data=seriesOne.data;
      for (let i=0;i<data.length;i++){
        data[i][1]=null;
      }
      this.forecastTableData=[];//初始化预测表格数据
      let result=this.forecastResult;//获取预测结果数据
      for (let i=0;i<result.length;i++){
        let dataIdx=-1;
        for (let j=0;j<data.length;j++){
          if (data[j][0]==result[i].time){
            dataIdx=j;
            break
          }
        }
        if (dataIdx!=-1){
          data[dataIdx][1]=parseFloat(result[i].data);
        }
        else {
          let dataOne=[];
          dataOne.push(result[i].time);
          dataOne.push(parseFloat(result[i].data));
          data.push(dataOne);
          xAxis.userCategory.push(result[i].time);
        }


        //添加预测表格数据，todo 待算法完善，目前使用模拟数据
        let tableDataOne={};
        tableDataOne.time=result[i].time;
        tableDataOne.data=parseFloat(result[i].data);
        //tableDataOne.cumulative=1;//累产
        //tableDataOne.degree=1;//采出程度
        //tableDataOne.speed=1;//采油速度
        this.forecastTableData.push(tableDataOne);
      }
      series.push(seriesOne);//添加对应拟合数据段的曲线绘制信息
      this.option=option;
      if (val=="ok"){
        this.viewBoxForecast=false;
      }
      console.log("forecastTableData:",this.forecastTableData);
    },
    //产量预测——开始日期限定条件
    disabledDateStart(time) {
      //返回 ：true：禁止选择，fasle：允许选择
      return this.frameYear.startTime != null ? moment(time).format("YYYYMM")<=this.frameYear.startTime :false;
    },
    //产量预测——结束日期限定条件
    disabledDateEnd(time) {
      return time.getTime() < this.forecastData.startTime;
    },
    //拟合报表选中行触发，记录点击拟合数据段位置
    forecastCurrentChange(val){
      console.log(val)
      if (val==null){
        return
      }
      for (let i=0;i<this.fittingDatas.length;i++){
        if (val.name==this.fittingDatas[i].name){
          this.forecastIndex=i;
          break;
        }
      }
      console.log("forecastIndex:",this.forecastIndex);
    },

    //双击表格触发——修改内容
    editData(row, column){
      // console.log(row);
      // console.log(column);
      // console.log(column.label);
      // console.log(column.property);

      if(column.property=="time"){
        return
      }
      row[column.property + "isShow"] = true;//显示编辑框
      this.$nextTick(() => {
        this.$refs[column.property] && this.$refs[column.property].focus(); //聚焦编辑框
      })
    },
    //编辑框失去焦点后触发，隐藏编辑框
    alterData (row, column) {
      row[column.property + "isShow"] = false;
      console.log(this.forecastTableData);
    },
    //预测表格相关数据提交
    forecastOk(){
      console.log(this.templateInfo);
      console.log(this.option[this.selectedChartIndex]);
      let now = new Date();
      let y = now.getFullYear();
      let m = now.getMonth()+1;
      let d = now.getDate();
      let h = now.getHours();
      let mi = now.getMinutes();
      let s = now.getSeconds();
      m = m>9?m:"0"+m;
      d = d>9?d:"0"+d;
      h = h>9?h:"0"+h;
      mi = mi>9?mi:"0"+mi;
      s = s>9?s:"0"+s;
      now = y+"-"+m+"-"+d+"|"+h+":"+mi+":"+s;

      let url = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/record/add";
      // let token = "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiMDA2OTk4OTMiLCJ1c2VyX2lkIjoiMWNwM2RsYWQ4cm9hNTRsc29jeWl0MTI2Iiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA1ODgyIiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnY7lrrbph5EiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY1MzQ3MjA3MCwiZXhwIjoxNjU2MDY0MDcwfQ.Wly0YfUnzHZEMbnzaOqXiDtOqieOKdSRQAkj6z6WHUrby4-7vCcLLf3SJhiOZkYIDI234OvNV9KPqFQm4rcHkubPOZwU2FHbSLUdPMCAe5cneDDCkhL_lWH8SDGV0prZh1jwcgoa5_jCyqVc0tJpen17M8bPIY3biLVavwUPUffYLjzWSqj-qgI8C395dJ6y2mwKtN7mSGxqlnZjW_LH-07M-1f6hcg6fJaKRE-Vdr6L4ngQ5Es_j4_7ExywP71nQbQxuKYPRpujv5RtK5vAXG4RT6uMmytjwVNc2DmRshSWFKaGow2DROpeVJlbQIN6tM_KRuRYwURsfH6ygbtjkA";
      //let token = localStorage.getItem("lyqtJwt");
      let forecastData={};
      forecastData.fittingData=this.fittingDatas[this.forecastIndex];
      forecastData.forecastData=this.forecastData;
      forecastData.forecastTableData=this.forecastTableData;
      console.log("forecastData:",forecastData);

      let data = {};
      data.pageId = this.templateInfo.pageid;
      data.pageName = this.templateInfo.modulename==this.templateInfo.label ? this.templateInfo.modulename : this.templateInfo.modulename+"—"+this.templateInfo.label;
      data.dataUrl = this.option[this.selectedChartIndex].a_dataSource;
      data.uploadType="预测数据";
      data.forecastData=forecastData;
      data.authorization = this.token;
      data.uploadTime = now;
      axios.post(url,data).then(res=>{
        console.log(res)
        ElMessage(res.data.msg)
      })
    },

    //时间选择（年度）——开始日期限定条件
    disabledFrameYearStart(time) {
      return this.frameYear.endTime!=null ? time.getFullYear() >= this.frameYear.endTime : false;
    },
    //时间选择（年度）——结束日期限定条件
    disabledFrameYearEnd(time) {
      return time.getFullYear() <= this.frameYear.startTime;
    },
    //时间选择（年月）——开始日期限定条件
    disabledFrameMonStart(time) {
      //返回 ：true：禁止选择，fasle：允许选择
      return this.frameYear.endTime != null ? moment(time).format("YYYYMM")>=this.frameYear.endTime :false;
    },
    //时间选择（年月）——结束日期限定条件
    disabledFrameMonEnd(time) {
      return moment(time).format("YYYYMM") <= this.frameYear.startTime;
    },

    //时间选择（年月日）——开始日期限定条件
    disabledFrameDayStart(time) {
      //返回 ：true：禁止选择，fasle：允许选择
      return this.frameYear.endTime != null ? moment(time).format("YYYY-MM-DD")>=this.frameYear.endTime :false;
    },
    //时间选择（年月日）——结束日期限定条件
    disabledFrameDayEnd(time) {
      return moment(time).format("YYYY-MM-DD") <= this.frameYear.startTime;
    },
    //tree组件 搜索筛选 过滤节点——选井页面（指标分析）
    relationsFilterNode(value, data) {
      if (!value) return true;
      return data.label
          .indexOf(value) !== -1;
    },
    //研究井位点击
    wellDataClick(){
      if(this.$store.state.isJump){
        this.$store.state.isJump = false;
        return
      }
      // if(this.wellDataClickNum == 0)
      {
        this.wellDataClickNum ++;
        let wells=this.$store.state.wellData;
        //未勾选区块的情况
        if (typeof wells[0]=="object"){
          wells=[];
        }
        this.wells=wells;
        if(this.wells.length == 0) return;
        console.log(this.wells);
        //井组图点击单井不触发
        if(this.chartType=="normal"){
          if (this.fittingDatas.length!=0){
            ElMessageBox.confirm(
              '当前页面存在拟合配置信息，切换会清空配置，是否切换?',
              '提醒',
              {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning',
              }
            )
              .then(() => {
                this.fittingDatas=[];//清空拟合数据集
                this.wellsTimeConfig();
              })
              .catch(() => {
                console.log(1);
                return;
              })
          }else {
            if(this.templateInfo != undefined && this.templateInfo.type=='chart_wellGroup'){
              this.preSelectWellFunc();
            }
            else {
              // this.wellsTimeConfig();
            }
          }
        }
      }

    },
    //研究井位点击不刷新
    wellDataClickWithoutRefresh(){
      if(this.$store.state.isJump){
        this.$store.state.isJump = false;
        return
      }
      // if(this.wellDataClickNum == 0)
      {
        this.wellDataClickNum ++;
        let wells=this.$store.state.wellData;
        //未勾选区块的情况
        if (typeof wells[0]=="object"){
          wells=[];
        }
        this.wells=wells;
        console.log(this.wells);
      }
    },
    //默认勾选个人井组的中心井，关联井（井组曲线）
    getwellgroup(){
      console.log("1111111111")
      console.log(this.wells)
      console.log(this.wellgroupData)
      console.log("1111111111")
      this.center_wells = [];
      this.relation_wells = [];
      this.wellgroupData = this.$store.getters.getWellgroupData;
      console.log(this.wellgroupData)
      if (this.wells[3] == "04" && this.wellgroupData.length > 0) {
        if (this.wellgroupData[0].children != undefined && this.wellgroupData[0].children.length > 0) {
          this.wellgroupData[0].children.forEach(item => {
            item.children.forEach(it => {
              if (it.WELLPKEY == "1" && this.center_wells.length == 0) {
                this.center_wells.push(it.label);
              }
              //todo 目前限制从井个数不大于5
              if (it.WELLPKEY == "0" && this.relation_wells.length <= 4) {
                this.relation_wells.push(it.label);
                this.defcheckedBlk.push(it.id);
              }
            })
          })
        }
        else{
          this.wellgroupData.forEach(it => {
            if (it.WELLPKEY == "1" && this.center_wells.length == 0) {
              this.center_wells.push(it.label);
            }
            //todo 目前限制从井个数不大于5
            if (it.WELLPKEY == "0" && this.relation_wells.length <= 4) {
              this.relation_wells.push(it.label);
              this.defcheckedBlk.push(it.id);
            }
          })
        }
      }
      console.log("center_wells:",this.center_wells)
      console.log("relation_wells:",this.relation_wells)
    },

    //双击触发修改配置模板的名称
    dblclickConfigName(item) {
      console.log("配置模板信息：", item);
      //只能修改用户模板名称
      if (this.switch_config_name.indexOf("（公用）") != -1) {
        return
      }
      item.config_nameOld = item.config_name.toString();//保留旧名称
      item.config_name = item.config_name.replace("（用户）", "");//去除用户标识
      item.isShow = true;
      this.$nextTick(() => {
        this.$refs[item.config_name] && this.$refs[item.config_name].focus(); //聚焦编辑框
      })
    },
    //提交修改配置模板名称
    updateConfigName(item,idx) {
      item.config_name = item.config_name + "（用户）";
      item.isShow = false;
      //未修改时退出
      if (item.config_nameOld == item.config_name)
        return
      //名称重复，退出
      let isRepeatName = false;
      this.changeConfigList.forEach((i, index) => {
        let name = i.config_name.replace("（用户）", "").replace("（公用）", "");
        let onName = item.config_name.replace("（用户）", "").replace("（公用）", "");
        //名称重复判定，排除自己
        if (onName == name && idx != index) {
          isRepeatName = true;
        }
      })
      if (isRepeatName){
        ElMessage("模板名称不能重复！");
        item.config_name = item.config_nameOld;
        return;
      }

      //修改名称后，单选选中丢失，需更新
      if (item.config_nameOld == this.switch_config_name) {
        this.switch_config_name = item.config_name;
      }
      //当修改当前选择模板时，修改选中信息
      if (item.config_nameOld == this.changeConfigNow) {
        this.switch_config_name = item.config_name;
        this.changeConfigNow = item.config_name;
      }
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/updatecConfigName",
        method: "post",
        headers: {
          "Content-Type": "application/json"
        },
        data: {
          item: item,
          type:"chart"
        }
      }).then(res => {
        console.log(res);
        ElMessage.success(res.data.message)
      }).catch(err => {
        console.log(err);
      })
    },
  },
  computed:{
    //计算单井数据变化
    wellDatas(){
      return this.$store.getters.getWellData;
    },
    //计算左边栏井数据变化
    wellgroupDatas(){
      return this.$store.getters.getWellgroupData;
    },
    //计算右边栏状态
    isRightCollapse(){
      return this.$store.getters.getIsRightCollapse;
    },
    //计算左边栏状态
    isLeftCollapse(){
      return this.$store.getters.getIsLeftCollapse;
    },
    IsDataLoading(){
      return this.isDataLoading;
    },


  },
  watch:{
    //监听获取时间数据（年月）
    frameTime(){
      if(this.frameTime) {
        console.log("frameTimeWatch:",this.frameTime[0],this.frameTime[1]);
        this.$store.state.frameTime= this.frameTime;//保留时间

        //页面初始化加载时间，给时间范围选择器赋值
        if (this.frameTimeType=='年' || this.frameTimeType=='年月'){
          this.frameYear.startTime=this.frameTime[0];
          this.frameYear.endTime=this.frameTime[1];
        }
        this.fittingDatas=[];//清空拟合数据集
      }
    },
    //监听单井数据变化
    wellDatas(){
      console.log(1111111111111111,this.wellDatas)
      this.wellDataClick()
    },
    //监听井组数据变化
    wellgroupDatas(){
      this.wellgroupData=this.$store.state.wellgroupData;
      console.log(this.wellgroupData);
      if(this.chartType=="wellgroup"){
        this.getwellgroup();
        this.wellsTimeConfig();
      }
    },
    //监听右边栏状态
    isRightCollapse() {
      //console.log("右边栏状态:", this.$store.state.isRightCollapse);
      this.wellsTimeConfig();
    },
    //监听左边栏状态
    isLeftCollapse(){
      //console.log("左边栏状态:",this.$store.state.isLeftCollapse)
      this.wellsTimeConfig();
    },

    templateInfo(){
      this.info=this.templateInfo;
      if(this.templateInfo)
      {
        this.config_name = this.templateInfo.template
        this.getConfig(true);
      }
    },
    option(){
      console.log("option:",this.option);
      this.loading=true;
    },

    //监听 chartCongfig组件，下拉框数据源初始加载完成后，调用changes()方法
    isDataLoading: function () {
      console.log("配置数据加载标识:",this.isDataLoading);
      if (this.isDataLoading){
        this.$refs.newChart.changes(this.chartType);
        this.$refs.newChart.IsFitting = this.isFitting;
        this.loadingChaet=false;
      }
    },

    //监听切换配置
    switch_config_name: {
      handler() {
        console.log(this.switch_config_name);
      }
    },
    //监听拟合选值展示框的状态，隐藏时，给IsSee标识赋值：false; 清空拟合曲线
    viewBoxSelection:function (){
      if (!this.viewBoxSelection){
        this.IsSee=false;
      }
      console.log("IsSee:",this.IsSee);
    },
    //监听拟合时间集的长度变化,为空时,重新加载初始配置(未进行绘制拟合曲线)
    'fittingDatas.length': {
      handler(newValue, oldValue) {
        console.log(newValue,oldValue);
        if (newValue ==0) {
          this.option = JSON.parse(JSON.stringify(this.optionCopy));//加载初始配置(未进行绘制拟合曲线)
        }
      }
    },

    //监听井组数据变化（指标分析）
    relations:{
      handler(){
        localStorage.setItem("relations",JSON.stringify(this.relations));
        console.log("relations:", this.relations);
      },
      deep:true
    },
    //监听选井（指标分析）筛选内容变化
    relation_grupone_filterText(val) {
      if (this.$refs.relationsOneTree != undefined)
        this.$refs.relationsOneTree.filter(val);
      if (this.$refs.centerWellTree != undefined)
        this.$refs.centerWellTree.filter(val);
    },
    relation_gruptwo_filterText(val) {
      if (this.$refs.relationsTwoTree != undefined)
        this.$refs.relationsTwoTree.filter(val);
      if (this.$refs.relationWellTree != undefined)
        this.$refs.relationWellTree.filter(val);
    },
  }

}
</script>

<style scoped>

.newChartBg{
  position: fixed;
  z-index: 1999;
  width: 100%;
  height :100%;
  top: 0;
  left: 0;

  background-color: rgba(88,87,86,0.3);
}
.newChart{
  position: absolute;
  background:white;
  height: 545px;
  width: 1100px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.table{
  height:420px;
  overflow: auto;
  border: 1px solid #dcdfe6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  padding:10px;
  background: #fff;
  margin-left: 20px;
  margin-right: 20px;
}
.header{
  margin: 5px 0 10px 20px;
  font-size: 20px;
  font-family: "微软雅黑";
  font-weight: bold;
}
.newChart{
  padding:5px;
  background: #f4f4f4;
}
.btn{
  margin-top: 12px;
  text-align: right;
  margin-bottom: 10px;
  margin-right: 20px;

}
.forecastRow{
  margin-bottom: 15px;
}
</style>
<style>
.newChartBtn{
  /*margin-left: 10px;*/
  margin-bottom: 20px;
  display:inline-block;
}
.block{
  margin-top: 9px;
  /*margin-left: auto;*/
}
.wellsName{
  margin-left: auto;
}
</style>
<!--设置el—tree高亮选中样式-->
<style lang="less" scoped>
/deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  //设置颜色
  //background-color: #baf !important;
  color: red ;
}
</style>